import React from 'react'
import '../styles/hero.css'
import heroImage from '../images/image-mockups.png'
const Hero = () => {
	return <div className="hero">
		<div className="hero-left">
			<div>
				<h3>Next Generation degital banking</h3>
				<p>
					Take your financial life online. Your Easybank account will be a one-stop-shop for spending, saving, budgeting, inversting, and much more.
				</p>
				<button>Request Invite</button>
			</div>
		</div>
		<div className="hero-right">
			<img src={heroImage} />
		</div>

	</div>
}

export default Hero;